// 카카오톡 채널 URL
export const KAKAO_CHANNEL_URL = "https://pf.kakao.com/_WQzFn";

// 카카오톡 채널명
export const KAKAO_CHANNEL_NAME = "이규호사주TV";

// 포트원 스토어 ID
export const PORTONE_STORE_ID = `${process.env.REACT_APP_PORTONE_STORE_ID}`;

// 포트원 채널 키
export const PORTONE_CHANNEL_KEY = `${process.env.REACT_APP_PORTONE_CHANNEL_KEY}`;

// 프리미엄 만세력 사주 가격
export const PREMIUM_MANSEOL_PRICE = Number(
  `${process.env.REACT_APP_PREMIUM_MANSEOL_PRICE}`
);
